module.exports = __webpack_public_path__ + "static/4import-91e6d46b4dbbe3c01affe77bf6ce2aa9.png";